import React from 'react';
import './services.css';
import { Helmet } from "react-helmet";

import whatsapp from '../../Assets/whatsapp.png';
import call from '../../Assets/call.png';
import CheekDimplePiercingImage from '../../Assets/Piercing Services/cheek dimple piercing (2).png';
import Footer from '../contactus/contactus';

const handleWhatsAppClick = (message) => {
  const url = `https://wa.me/971567257579?text=${encodeURIComponent(message)}`;
  window.open(url, "_blank");
};

function CheekDimplePiercing() {
  return (
    <div>
      <div className="earlobe-container">
        <Helmet>
          <title>Cheek Dimple Piercing UAE | 200-250 AED</title>
        </Helmet>

        <div className="floating-buttons">
          <div
            className='whatsapp-button'
            onClick={() => handleWhatsAppClick("I am interested in Cheek Dimple Piercing")}
          >
            <img src={whatsapp} alt="WhatsApp" />
          </div>

          <a href="tel:+971567257579" className="call-button">
            <img src={call} alt="Call" />
          </a>
        </div>

        <h1 className="earlobe-title">
          Cheek Dimple Piercing 200-250 AED
        </h1>

        <div className="earlobe-image-wrapper">
          <img src={CheekDimplePiercingImage} alt="Cheek Dimple Piercing" />
        </div>

        <div className="earlobe-content">
          <h3>Cheek Dimple Piercing</h3>

          <p>
            Enhance your smile with our professional cheek dimple piercing services in the UAE, available at an affordable price range of 200–250 AED. Cheek dimple piercing is a playful and charming facial piercing designed to mimic the appearance of natural dimples, adding a unique and attractive touch to your overall look. This stylish piercing is placed on the cheeks in a way that enhances facial expressions, creating a soft and appealing aesthetic that stands out beautifully. Perfect for individuals who want to add personality and charm to their smile, cheek dimple piercing offers a trendy yet elegant way to express your individuality. Whether you prefer subtle studs or decorative jewelry, our expert specialists ensure precise placement for a symmetrical and visually pleasing result.
          </p>

          <p>
            At our piercing studio, safety, hygiene, and comfort are our top priorities. Our certified professionals use sterile, single-use, high-quality equipment to perform each cheek dimple piercing with accuracy and care. We strictly follow professional hygiene protocols to maintain a clean and sanitized environment, minimizing the risk of infection and ensuring a safe and smooth experience. Facial piercings require advanced expertise due to their sensitivity, and our experienced specialists are trained to perform the procedure carefully while minimizing discomfort and ensuring proper alignment.
          </p>

          <p>
            Cheek dimple piercing is ideal for those who want a bold yet playful look that enhances their natural features. This piercing creates the illusion of dimples, making your smile more expressive and eye-catching. It pairs well with other facial piercings such as lip or nose piercings, allowing you to create a personalized and stylish aesthetic. Our specialists take the time to understand your preferences and guide you in choosing the best placement and jewelry options to suit your facial structure and desired appearance.
          </p>

          <p>
            The procedure is typically completed within a short time, making it convenient for clients with busy schedules. We also provide high-quality, hypoallergenic starter jewelry that is safe for sensitive skin, helping to prevent irritation and ensuring a comfortable healing process. Our goal is to deliver a safe, stylish, and comfortable experience from start to finish.
          </p>

          <p>
            Our clean, welcoming, and professional environment ensures that every client feels relaxed and confident throughout their visit. We understand that cheek piercings can feel intimidating, especially for first-time clients, and our friendly staff is always available to answer your questions and provide reassurance. From consultation to completion, we focus on delivering a smooth and positive experience tailored to your needs.
          </p>

          <p>
            Aftercare is especially important for cheek dimple piercings due to their placement, and we provide detailed instructions to help you care for them properly. Our specialists will guide you on cleaning routines, oral hygiene practices, and precautions to avoid infection or irritation. Following proper aftercare ensures better healing and helps maintain the health and appearance of your piercing.
          </p>

          <p>
            Our cheek dimple piercing services in the UAE combine affordability with premium quality, offering transparent pricing with no hidden charges. Booking your appointment is quick and convenient, allowing you to choose a time that fits your schedule. We aim to provide minimal waiting time and a seamless experience from start to finish.
          </p>

          <p>
            Choose our trusted cheek dimple piercing services in the UAE for a safe, hygienic, and professional experience. With experienced specialists, precise techniques, and a strong focus on customer satisfaction, we help you achieve a playful and charming look effortlessly. Book your cheek dimple piercing appointment today and add a unique touch to your smile with confidence and expert care.
          </p>

          <button
            className="book-btn"
            onClick={() => handleWhatsAppClick("I want to book Cheek Dimple Piercing")}
          >
            Book Now
          </button>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default CheekDimplePiercing;